import React, { useEffect, useRef, useState } from "react";
import dropin, { Dropin } from "braintree-web-drop-in";

interface BraintreeDropInProps {
  onPayment: (data: any) => void;
  amount: number;
  order: any;
  setPaymentProcessing: (processing: boolean) => void;
  paymentProcessing: boolean;
}

const BraintreeDropIn: React.FC<BraintreeDropInProps & { amount: number, order: any , onPayment: (data: any) => void, setPaymentProcessing: (processing: boolean) => void, paymentProcessing: boolean}> = ({ onPayment, amount, order, setPaymentProcessing, paymentProcessing }) => {
  const dropinInstance = useRef<Dropin | null>(null);
  const [clientToken, setClientToken] = useState<string | null>(null);

  useEffect(() => {
    // Fetch client token from your backend
    fetch("https://flipify-api.onrender.com/api/client_token") // Replace with your actual API endpoint
      .then((res) => res.json())
      .then((data) => setClientToken(data.client_token))
      .catch((error) => console.error("Error fetching client token:", error));
  }, []);

  useEffect(() => {
    if (clientToken) {
      dropin.create(
        {
            venmo: /Mobi|Android/i.test(navigator.userAgent),
          authorization: clientToken,
          container: "#braintree-drop-in",
        },
        (err, instance) => {
          if (err) {
            console.error("Braintree Drop-in UI error:", err);
            return;
          }
          dropinInstance.current = instance as any;
        }
      );
    }
  }, [clientToken]);

  const handlePayment = async () => {
    setPaymentProcessing(true);
  
    try {
      if (!dropinInstance.current) {
        console.error("Braintree instance not initialized");
        setPaymentProcessing(false);
        return;
      }
  
      dropinInstance.current.requestPaymentMethod(async (err, payload) => {
        if (err) {
          console.error("Payment method request error:", err);
          setPaymentProcessing(false);
          return;
        }
  
        try {
          const fullOrder = await order;
  
          const res = await fetch("https://flipify-api.onrender.com/api/checkout", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              payment_method_nonce: payload.nonce,
              order_details: { ...fullOrder, amount },
            }),
          });
  
          const data = await res.json();
          console.log("Payment response:", data);
          onPayment(data);
        } catch (paymentErr) {
          console.error("Payment error:", paymentErr);
        } finally {
          // 🔥 this is the REAL end of the payment flow
          setPaymentProcessing(false);
        }
      });
  
    } catch (err) {
      console.error("Payment error:", err);
      setPaymentProcessing(false);
    }
  };
  

  return (
    <div>
      <div id="braintree-drop-in"></div>
        <button
          onClick={handlePayment}
          disabled={paymentProcessing}
          style={{
            display: "block",
            margin: "0 auto",
            padding: "10px 20px",
            fontSize: "16px",
            fontWeight: "bold",
            color: "#fff",
            backgroundColor: paymentProcessing ? "#6c757d" : "#007bff",
            border: "none",
            borderRadius: "5px",
            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
            cursor: "pointer",
            transition: "background-color 0.3s, transform 0.3s",
          }}
          onMouseOver={(e) => (e.currentTarget.style.backgroundColor = paymentProcessing ? "#6c757d" : "#0056b3")}
          onMouseOut={(e) => (e.currentTarget.style.backgroundColor = paymentProcessing ? "#6c757d" : "#007bff")}
          onMouseDown={(e) => (e.currentTarget.style.transform = "scale(0.98)")}
          onMouseUp={(e) => (e.currentTarget.style.transform = "scale(1)")}
        >
          {paymentProcessing ? "Processing..." : "Pay Now"}
        </button>
    </div>
  );
};

export default BraintreeDropIn;
